import { convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import React, { useContext, useEffect, useRef, useState } from 'react'

import {
  ReleaseNotes,
  addOrUpdateReleaseNote,
  getReleaseNoteback,
} from '../../../assets/ts/data/release-note'
import { convertDate } from '../../../assets/ts/date-and-time/date-and-time'
import { isChangeDetected } from '../../../assets/ts/general/general'
import { isInputValid } from '../../../assets/ts/validations/validations'
import Alert from '../../../components/alert/alert'
import Buttons from '../../../components/buttons/buttons'
import { UserContext } from '../../../store/user-context-provider'
import CustomSelect from '../../../utils/controls/custom-select'
import InputText from '../../../utils/controls/input-text'
import RichTextEditor from '../../../utils/controls/rich-text-edit'
import { IsArchived } from '../../../utils/controls/select-options-data'

const AddEditView = (props: any) => {
  const { me } = useContext(UserContext)
  const validation = {
    version: true,
  }
  const [releaseNoteValidations, setReleaseNoteValidations] = useState(validation)
  const [userInputs, setUserInputs] = useState({
    'Known Issues': props.showEdit ? props.details.KnownIssues : '',
    'New Features': props.showEdit ? props.details.NewFeatures : '',
    'Resolved Issues': props.showEdit ? props.details.ResolvedIssues : '',
    archive: props.showEdit ? props.details.IsArchived : false,
    version: props.showEdit ? props.details.titlename : '',
  })
  const [existingReleaseNote, setExistingReleaseNote] = useState({
    'Known Issues': props.showEdit ? props.details.KnownIssues : '',
    'New Features': props.showEdit ? props.details.NewFeatures : '',
    'Resolved Issues': props.showEdit ? props.details.ResolvedIssues : '',
    archive: props.showEdit ? props.details.IsArchived : false,
    version: props.showEdit ? props.details.titlename : '',
  })
  const [showNochanges, setShowNochanges] = useState(false)
  const resetSiteFeedbackForm = () => {
    setUserInputs({
      'Known Issues': '',
      'New Features': '',
      'Resolved Issues': '',
      archive: false,
      version: '',
    })
    setReleaseNoteValidations(validation)
  }

  const checkValidation = (): boolean => {
    if (props.showEdit) {
      const edittedReleaseNote = {...userInputs}
      edittedReleaseNote['Known Issues'] = draftToHtml(
        convertToRaw(userInputs['Known Issues'].getCurrentContent())
      )
      edittedReleaseNote['New Features'] = draftToHtml(
        convertToRaw(userInputs['New Features'].getCurrentContent())
      )
      edittedReleaseNote['Resolved Issues'] = draftToHtml(
        convertToRaw(userInputs['Resolved Issues'].getCurrentContent())
      )

      const changeIsDetected = isChangeDetected(edittedReleaseNote, existingReleaseNote)
      if (!changeIsDetected) {
        setShowNochanges(true)
        return changeIsDetected
      }
    }
    const isVersionValid = isInputValid(userInputs.version)
    setReleaseNoteValidations({
      version: isVersionValid,
    })
    return isVersionValid
  }
  const onSubmit = async () => {
    const isValid = checkValidation()
    if (isValid) {
      const releaseNoteObj: ReleaseNotes = {
        IsArchived: userInputs.archive,
        ItemCreated: new Date(),
        ItemCreatedBy: me.rid,
        ItemModified: new Date(),
        ItemModifiedBy: me.rid,
        KnownIssues: draftToHtml(convertToRaw(userInputs['Known Issues'].getCurrentContent())),
        NewFeatures: draftToHtml(convertToRaw(userInputs['New Features'].getCurrentContent())),
        ResolvedIssues: draftToHtml(convertToRaw(userInputs['Resolved Issues'].getCurrentContent())),
        VersionName: userInputs.version,
      }
      if (props.showEdit) {
        releaseNoteObj.ItemModified = new Date()
        releaseNoteObj.ItemModifiedBy = me.rid
        delete releaseNoteObj.ItemCreated
        delete releaseNoteObj.ItemCreatedBy
        releaseNoteObj.eKey = props.details.eKey
        releaseNoteObj.eTag = props.details.eTag
      }
      try {
        const succesfullReleaseNote = await addOrUpdateReleaseNote(releaseNoteObj)
        resetSiteFeedbackForm()
        if (succesfullReleaseNote !== undefined) {
          const allReleaseNote = await getReleaseNoteback({ orderBy: 'ItemCreated' })
          if (allReleaseNote.length > 0) {
            const releaseNote =
              allReleaseNote?.map((rn, ind) => ({
                Created: ` ${rn.ItemCreatedBy?.properties.defaultDisplay} |  ${convertDate(
                  rn.ItemCreated,
                  'date'
                )}`,
                Id: ind + 1,
                IsArchived: rn.IsArchived,
                KnownIssues: rn.KnownIssues ? rn.KnownIssues : '',
                Modified: ` ${rn.ItemModifiedBy?.properties.defaultDisplay} |  ${convertDate(
                  rn.ItemModified,
                  'date'
                )}`,
                NewFeatures: rn.NewFeatures ? rn.NewFeatures : '',
                ResolvedIssues: rn.ResolvedIssues ? rn.ResolvedIssues : '',
                'Version and Date': <span>{rn.VersionName}</span>,
                eKey: rn.eKey,
                eTag: rn.eTag,
                titlename: rn.VersionName,
              })) || []
            props.cancel()
            props.setReleaseNoteItems(releaseNote)
          }
        }
        props.setShowAddPopup(false)
      } catch (error) {
        console.error('Error while adding or updating site release note:', error)
      }
    }
  }
  const handleChange = (value: boolean) => {
    setUserInputs({ ...userInputs, archive: value })
  }
  const titleRef: any = useRef<any>(null)
  const descriptionRef: any = useRef<any>(null)
  useEffect(() => {
    const element: any = document.getElementById('VersionDate')
    if (element) {
      descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'start' })
      element.focus()
      element?.scrollIntoView(false)
    }
  }, [props?.showEdit, props?.showAddPopup])

  const handleChangeRichTextNewFeature = (e) => {
    setUserInputs((prev) => ({ ...prev, 'New Features': e }))
  }
  const handleChangeRichTextResolvedIssue = (e) => {
    setUserInputs((prev) => ({ ...prev, 'Resolved Issues': e }))
  }
  const handleChangeRichTextKnownIssue = (e) => {
    setUserInputs((prev) => ({ ...prev, 'Known Issues': e }))
  }
  const nochangesAlert = (e) => {
    setShowNochanges(false)
    if (e === 'OK') {
      props?.cancel()
      resetSiteFeedbackForm()
      setExistingReleaseNote({})
    }
  }
  return (
    <div
      className={
        props?.showAddPopup
          ? 'mx-2 border-radius whitebg border-primary p-2'
          : 'settingseditpopup w-100 position-relative border-top1 p-2'
      }
      id='scroll'
    >
      {props?.showAddPopup && (
        <div className='py-2 border-bottom1'>
          <h4
            aria-label='ADD RELEASE NOTES'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            ADD RELEASE NOTES
          </h4>
        </div>
      )}
      {showNochanges && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={'No Changes Detected'}
          onClick={nochangesAlert}
          yes='OK'
        />
      )}
      <div className='row'>
        <div className='col-sm-12 col-lg-12 mb-2' ref={titleRef}>
          <InputText
            changeHandler={(event: { target: { value: React.SetStateAction<string> } }) =>
              setUserInputs({ ...userInputs, version: event.target.value })
            }
            className='form-sm'
            error={!releaseNoteValidations.version}
            formClassName='ms-auto form-vertical'
            info='Version and Date'
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'poppins-medium font-12 title-color2 mb-1',
              id: 'VersionDate',
              maxLength: 255,
              name: 'Version and Date',
              placeholder: 'Version 01: 2024 June 4',
              value: userInputs.version,
            }}
            isInfo
            isMandatory
            label='Version and Date'
          />
        </div>
        <div className='col-sm-12 col-lg-12 mb-2'>
          <RichTextEditor
            editorValue={userInputs['New Features']}
            formClassName='d-flex flex-column'
            info='New Features '
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: ' NewFeatures ',
              name: 'New Features',
              placeholder: 'Enter New Features',
            }}
            isInfo
           
            label='New Features'
            maxCharLimit={800}
            sendValue={handleChangeRichTextNewFeature}
            setUserInputs={setUserInputs}
            userInputs={userInputs}
          />
        </div>
        <div className='col-sm-12 col-lg-12 mb-2'>
          <RichTextEditor
            editorValue={userInputs['Resolved Issues']}
            formClassName='d-flex flex-column'
            info='Resolved Issues'
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: ' ResolvedIssues ',
              name: 'Resolved Issues',
              placeholder: 'Enter Resolved Issues',
            }}
            isInfo
           
            label='Resolved Issues'
            maxCharLimit={800}
            sendValue={handleChangeRichTextResolvedIssue}
            setUserInputs={setUserInputs}
            userInputs={userInputs}
          />
        </div>
        <div className='col-sm-12 col-lg-12 mb-2'>
          <RichTextEditor
            editorValue={userInputs['Known Issues']}
            formClassName='d-flex flex-column'
            info='Known Issues '
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: ' KnownIssues ',
              name: 'Known Issues',
              placeholder: 'Enter Known Issues',
            }}
            isInfo
           
            label='Known Issues'
            maxCharLimit={800}
            sendValue={handleChangeRichTextKnownIssue}
            setUserInputs={setUserInputs}
            userInputs={userInputs}
          />
        </div>
        {props.showEdit && (
          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='IsArchived'
              info='IsArchived'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Is Archived'
              menuPosition={'fixed'}
              name='Is Archived'
              onChange={(e) => {
                handleChange(e.value)
              }}
              options={IsArchived}
              value={userInputs.archive}
            />
          </div>
        )}
      </div>
      <div className='d-flex py-1 flex-wrap'>
        <div className='ms-auto settingsbtns d-flex'>
          {props?.showAddPopup && (
            <>
              <Buttons
                className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                icon='icon-save font-11 pe-1'
                label='Save'
                onClick={() => {
                  onSubmit()
                }}
                type='button'
              />
              <Buttons
                className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                icon='icon-close color-primary font-9 pe-1'
                label='Cancel'
                onClick={() => {
                  props?.filtersvalue(!props?.showAddPopup)
                }}
                type='button'
              />{' '}
            </>
          )}
          {!props?.showAddPopup && (
            <>
              <Buttons
                className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                icon='icon-update font-11 pe-1'
                label='Update'
                onClick={() => {
                  onSubmit()
                }}
                type='button'
              />
              <Buttons
                className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                icon='icon-close color-primary font-9 pe-1'
                label='Cancel'
                onClick={() => {
                  props?.cancel()
                }}
                type='button'
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default AddEditView
